export { useConsentPopUp } from "./useConsentPopUp";
